import { httpClient } from '@/api/httpClient';
import {
  mapApiResourceToCustomDomain,
  mapApiResourceToTenantCustomDomain,
  type CustomDomain,
  type CustomDomainApiResource,
  type TenantCustomDomain,
  type TenantCustomDomainApiResource,
} from './customDomainsApi.types';

const WORKSPACE_CUSTOM_DOMAINS_PATH = '/me/workspace/custom-domains';

function buildTenantCustomDomainsPath(tenantId: string): string {
  return '/tenants/' + tenantId + '/custom-domains';
}

export async function fetchWorkspaceCustomDomains(): Promise<CustomDomain[]> {
  const response = await httpClient.get<CustomDomainApiResource[]>(WORKSPACE_CUSTOM_DOMAINS_PATH);
  return response.data.map(mapApiResourceToCustomDomain);
}

export async function addWorkspaceCustomDomain(hostname: string): Promise<CustomDomain> {
  const response = await httpClient.post<CustomDomainApiResource>(WORKSPACE_CUSTOM_DOMAINS_PATH, {
    hostname,
  });
  return mapApiResourceToCustomDomain(response.data);
}

export async function checkWorkspaceCustomDomain(customDomainId: string): Promise<CustomDomain> {
  const response = await httpClient.post<CustomDomainApiResource>(
    WORKSPACE_CUSTOM_DOMAINS_PATH + '/' + customDomainId + '/check'
  );
  return mapApiResourceToCustomDomain(response.data);
}

export async function makeWorkspaceCustomDomainPrimary(
  customDomainId: string
): Promise<CustomDomain> {
  const response = await httpClient.post<CustomDomainApiResource>(
    WORKSPACE_CUSTOM_DOMAINS_PATH + '/' + customDomainId + '/make-primary'
  );
  return mapApiResourceToCustomDomain(response.data);
}

export async function removeWorkspaceCustomDomain(customDomainId: string): Promise<void> {
  await httpClient.delete(WORKSPACE_CUSTOM_DOMAINS_PATH + '/' + customDomainId);
}

export async function fetchTenantCustomDomains(tenantId: string): Promise<TenantCustomDomain[]> {
  const response = await httpClient.get<TenantCustomDomainApiResource[]>(
    buildTenantCustomDomainsPath(tenantId)
  );
  return response.data.map(mapApiResourceToTenantCustomDomain);
}

export async function disableTenantCustomDomain(
  tenantId: string,
  customDomainId: string
): Promise<TenantCustomDomain> {
  const response = await httpClient.post<TenantCustomDomainApiResource>(
    buildTenantCustomDomainsPath(tenantId) + '/' + customDomainId + '/disable'
  );
  return mapApiResourceToTenantCustomDomain(response.data);
}

export async function enableTenantCustomDomain(
  tenantId: string,
  customDomainId: string
): Promise<TenantCustomDomain> {
  const response = await httpClient.post<TenantCustomDomainApiResource>(
    buildTenantCustomDomainsPath(tenantId) + '/' + customDomainId + '/enable'
  );
  return mapApiResourceToTenantCustomDomain(response.data);
}
